import React from "react";
import './styles.scss';
import ResetPassword from '../../components/Auth/ResetPassword'; 

const ResetPasswordPage = (props: any) => {
    return <ResetPassword />
  }
  
  export default  ResetPasswordPage;